import { Injectable, Inject} from '@angular/core';
import {PolicyClientAdditionalFieldDO} from './policyClientAdditionalField.model'

export  class PolicyClientDO {

    public  id:Number = null;
	
	
	
	public  roleCd:String = null;

	
	public  clientId:Number = null;
		
	public  clientRefGuid:String = null;

	
	
	public  medicalClassCd:String = null;
	
	
	
	public  relationCd:String = null;

	
	
	public  deDupStatusCd:String = null;
	public policyClientAdditionalFieldDOs:PolicyClientAdditionalFieldDO[]=[];

	
	public  getId() {
		return this.id;
	}

	public  setId( id) {
		this.id = id;
	}
	
	public  getMedicalClassCd() {
		return this.medicalClassCd;
	}

	public  getClientId() {
		return this.clientId;
	}

	public  setClientId( clientId) {
		this.clientId = clientId;
	}

	public  setMedicalClassCd( medicalClassCd) {
		this.medicalClassCd = medicalClassCd;
	}

	public  getDeDupStatusCd() {
		return this.deDupStatusCd;
	}

	public  setDeDupStatusCd( deDupStatusCd) {
		this.deDupStatusCd = deDupStatusCd;
	}

	public  getRelationCd() {
		return this.relationCd;
	}

	public  setRelationCd( relationCd) {
		this.relationCd = relationCd;
	}
	
	public  getRoleCd() {
		return this.roleCd;
	}

	public  setRoleCd( roleCd) {
		this.roleCd = roleCd;
	}

	public  getClientRefGuid() {
		return this.clientRefGuid;
	}

	public  setClientRefGuid( clientRefGuid) {
		this.clientRefGuid = clientRefGuid;
	}

	public  getPolicyClientAdditionalFieldDOs() {
		return this.policyClientAdditionalFieldDOs;
	}
	public  setPolicyClientAdditionalFieldDOs( policyClientAdditionalFieldDOs:any[]) {
		this.policyClientAdditionalFieldDOs = policyClientAdditionalFieldDOs;
	}

}
